<template>
	<div class="tg-search-module bg-white abs-full">
		<div class="flex-container fixedSearchBar marginl20 marginr30" >
			<form action="" class="form pos-r flex1" v-on:submit.prevent="onSubmit()">
				<div class="input-search"></div>
				<input
				type="search"
				id="searchModuleInput"
				:placeholder="placeholder"
				v-model="data.value">
				<div class="input-reset" @click="cleanInput()" v-show="data.value"></div>
			</form>
			<span class="paddingl30 fs-14" @click="cancel">取消</span>
		</div>
		<!--搜索联想词-->
		<div class="bg-white paddingt40" v-if="suggestWordList.length">
			<div class="flex-container padding20 borderb" height="45" v-for="item in suggestWordList" @click="onSubmit(item.text, 'sg')">
				<p class="text-darker"><span v-text="item.leftText"></span><span class="text-lighter" v-text="item.centerText"></span><span v-text="item.rightText"></span><span v-if="!item.leftText && !item.centerText && !item.rightText">{{item.text}}</span></p>
				<div class="icon icon-store-skip text-light marginr10" @click.prevent.stop="changeInputToComplete(item.text)"></div>
			</div>
		</div>
		<div class="ttt marginl20 marginr30"></div>
		<!--最近搜索和热门搜索-->
		<search-guide
		:show-fresh="!isActivity"
		:fresh-data="freshSearchList"
		:hot-data="data.hotWords.items"
		:type="data.type"
		class="search-guide marginl20 marginr30"
		v-if="!suggestWordList.length"
		></search-guide>
	</div>
</template>
<style lang="scss">
	.tg-search-module{
		/*height: 100%;*/
		z-index:1000;
		display:none;
		color: #222;
	}
	.tg-search-module form input[type="search"]{
		    background: rgba(142, 142, 147, 0.12);
		    border-radius: 4px;
		    line-height: 20px;
		    padding-top: 4px;
		    padding-right: 30px;
		    padding-bottom: 4px;
		    padding-left: 40px;
		    text-align: left;
		    font-size: 14px;
		}
	.tg-search-module form input[type="search"]:focus{
		border-color: #ccc;
		outline: none;
	}
	.tg-search-module form .input-search{left:0}
	.tg-search-module form .input-reset{right:0;display: block;}
	.tg-search-module form .input-search,.input-reset{
			top:-2px!important;
			display: block;
	}
	.tg-search-module .fixedSearchBar{

		background-color: white;
		z-index: 1001;
		padding-top: 15px;
		padding-bottom: 5px;
		left: .4rem;
		right: .4rem;
	}
	.search-guide{
		overflow-y: scroll;
		height: calc(100% - 50px);
		-webkit-overflow-scrolling: touch;
	}
</style>
<script>
	import {maple} from "../../index";

	$.smartScroll = function(container, selectorScrollable) {
	    if (!selectorScrollable || container.data('isBindScroll')) {
	        return;
	    }
	    var data = {
	        posY: 0,
	        maxscroll: 0
	    };
	    container.on({
	        touchstart: function (event) {
	            var events = _.get(event,'originalEvent.touches[0]',event);
	            var elTarget = $(event.target);
	            if (!elTarget.length) {
	                return;
	            }
	            var elScroll;
	            if (elTarget.is(selectorScrollable)) {
	                elScroll = elTarget;
	            } else if ((elScroll = elTarget.parents(selectorScrollable)).length == 0) {
	                elScroll = null;
	            }

	            if (!elScroll) {
	                return;
	            }
	            data.elScroll = elScroll;
	            data.posY = events.pageY;
	            data.scrollY = elScroll.scrollTop();
	            data.maxscroll = elScroll[0].scrollHeight - elScroll[0].clientHeight;
	        },
	        touchmove: function () {
	            if (data.maxscroll <= 0) {
	                event.preventDefault();
	            }
	            var elScroll = data.elScroll;
	            var scrollTop = elScroll.scrollTop();
	            var events = event.touches[0] || event;
	            var distanceY = events.pageY - data.posY;
	            if (distanceY > 0 && scrollTop == 0) {
	                event.preventDefault();
	                return;
	            }
	            if (distanceY < 0 && (scrollTop + 1 >= data.maxscroll)) {
	                event.preventDefault();
	                return;
	            }
	        },
	        touchend: function () {
	            data.maxscroll = 0;
	        }
	    });
	    container.data('isBindScroll', true);
	};
	import "javascript/libs/tg/pageComponent/searchGuide/index.js";
    import itemService from 'javascript/libs/tg/api/item.js';
    import searchwebService from 'javascript/libs/tg/api/searchweb.js';
	import {setCookie,getCookie,removeCookie} from 'javascript/libs/tg/util/cookie.js';
	export default {
		props:{
			data:{
				type:Object,
				default:{
					value:'', // 选填 搜索词
					defaultPlaceholderValue:'', // 选填 placeholder优先级 带过来的placeholder defaultPlaceholderValue > defaultWord随机一个 > placeholder
					placeholder:'', // 必填 优先级最低的placeholder
					type:'index', // 必填 来源{百货:'mall',超市:'super',购物首页:'index',跨境:'overseas',专柜特卖：'counterSale'};
					hotWords:{}, // 选填  热门搜索词
					defaultWord:{} // 选填 默认搜索词
				}
			},
			type:{
				type:String,
				default: ''
			}
		},
		ready(){
			$.smartScroll($('.tg-search-module'),'.search-guide')
		},
		data:function(){
		    return {
                suggestWordList: [],
				isActivity:!!maple.url().params.activityId
			}
		},
		computed:{
			freshSearchList:function(){
				let freshSearchKeys = maple.pageIns.getCookie('freshSearchKeys');
				return freshSearchKeys?freshSearchKeys.split(','):[]
			},
			defaultWordObj:function(){
				return this.data.defaultWord || {};
			},
			defaultWordList:function(){
				if(this.defaultWordObj && this.defaultWordObj.items){
					return this.defaultWordObj.items
				}else{
					return [];
				}
			},
			hotWordsObj:function(){
				return this.data.hotWords || {};
			},
			hotWordsList:function(){
				if(this.hotWordsObj && this.hotWordsObj.items){
					return this.hotWordsObj.items
				}else{
					return [];
				}
			},
			placeholder:function(){
				/**
				 * TODO
				 * placeholder优先级 defaultPlaceholderValue > defaultWord随机一个 > placeholder
				 * @param  {[type]} defaultPlaceholderValue [如果有defaultPlaceholderValue代表用上页传过来的默认词]
				 * @param  {[type]} defaultWord [如果有defaultWord代表用后台设置默认的搜索词取一个随机值]
				 * @param  {[type]} placeholder [如果该页面不使用后台配置，或后台配置搜索词出问题，采用固定搜索词]
				 * @return {[type]} placeholder [返回一串字符串]
				 */
				let defaultPlaceholderValue = this.data.defaultPlaceholderValue
					,placeholder = this.data.placeholder
					,defaultWordList = this.defaultWordList;
				if(defaultPlaceholderValue){
					return defaultPlaceholderValue;
				}else if(defaultWordList){
					if(defaultWordList.length){
						let ranNum = Math.floor(defaultWordList.length*Math.random()) || 0;
						return defaultWordList[ranNum].title;
					}else{
						return placeholder;
					}
				}else{
					return placeholder;
				}
			}
			,searchInputWord(){
			    return _.trim(this.data.value);
			}
		},
		events:{
			freshSearch:function(item, type){
                this.$dispatch('searchMouleSubmit')
				this.toResultPage({words:item, type, srParams: 'sh'})
			}
		},
		watch:{
            searchInputWord(newVal){
		        let that = this;
		        if(that.timer){
		            clearTimeout(that.timer)
				}

                that.timer = setTimeout(that.getSuggestWordList,300,newVal);
			}
		},
		methods:{
			onSubmit:function(data, srParams){
				/**
				 * TODO提交之前
				 * 如果搜索词是空，跳转到placeholder对应的clickUrl
				 * 校验是否是热门搜索词或者后台配置的默认词，如果是直接跳转到设置好的clickUrl，不添加到搜索记录
				 * 校验是否是最近搜索词，如果是,要设置cookie的 freshSearchKeys ，把该词在原来的位置删掉
				 * 设置 cookie 的 freshSearchKeys ，把搜索词添加到首位，字符串用逗号隔开
				 */
				let value = _.trim(data || this.data.value)
					,page = maple.pageIns.page
					,isHotFlag = false
					,freshSearchKeys = maple.pageIns.getCookie('freshSearchKeys')
					;

				let preparedSearchList = this.hotWordsList.concat(this.defaultWordList)
					,freshSearchList = freshSearchKeys?freshSearchKeys.split(','):[];

				if(!!value && value !== 'null' && value !== 'undefined'){ // 如果输入框中有搜索词
					preparedSearchList.forEach((item,index)=>{
						if(item.title === value){
							this.cancel();
                            isHotFlag = true;
							_.delay(() => {
								maple.pageIns.changePage(item.clickUrl,{scp:page+'.search.0'});
								return;
							})

						}
					})
					freshSearchList.forEach((keys,index)=>{
						if(keys === value){
							freshSearchList.splice(index,1)
						}
					})
					if(!isHotFlag){
						const FROM = {STORE:'mall',STORENEW:'super',INDEX:'index',OVERSEAS:'overseas',COUNTERSALE: 'counterSale'};
						freshSearchList.unshift(value);
						maple.pageIns.setCookie('freshSearchKeys',freshSearchList.join(','),365);
						this.toResultPage({words:value,type:this.data.type, srParams});
					}
				}else{ // 搜索词为空,如果有后台配置的搜索词，反推出当前默认词的clickUrl
					let defaultWordList = this.defaultWordList;
					if(defaultWordList.length){
						defaultWordList.forEach(item=>{
							if(item.title === this.placeholder){
								this.cancel();
								_.delay(()=>{
									maple.pageIns.changePage(item.clickUrl,{scp:page+'.search.0'})
								})
							}
						})
					}
				}

				this.$dispatch('searchMouleSubmit',this,value)
			},
			cleanInput(){
					this.data.value='';
					$('#searchModuleInput').focus()
			},
			cancel(){
				maple.pageIns.page=window.pageStore;
				this.$el.style.display='none'
				this.$dispatch('searchMouleCancel',this)
				// 门店页点取消时让小汪显示
				if(this.data.type == 'super' || this.data.type == 'mall'){
					$('.tgIntel').show();
				}
				// 搜索结果页点取消时移除禁用滚动的属性
				this.$dispatch('enabledBodyScroll',this)
				// 点击取消时去掉搜索已经输入的内容
				this.data.value = '';
			},
			toResultPage({words,type, srParams}){
				let params = this.data.params
					,page = maple.pageIns.page
					;
				// 如果给组件配置了url参数，则把参数带到后面的url里面
				// 否则跳转到搜索结果页，有words和type
				if(params){
					delete params.scp;
					delete params.words;
					delete params.srParams;
					this.cancel();
					_.delay(() => {
						maple.pageIns.changePage('../search/searchResult.html',_.extend( {},params,{scp:page+'.search.0', words:words, srParams} ));
					})
				}else{
					this.cancel();
					_.delay(()=>{
						maple.pageIns.changePage('../search/searchResult.html',{scp:page+'.search.0'
						,words:words,type:type||'index', srParams});
					})
				}
			}
            ,changeInputToComplete(word){
			    let that = this;
				that.data.value = word
			}
			,getSuggestWordList(word){
			    let that = this
					,type = that.data.type
					,serviceHandler
				;
			    if(type === 'overseas'){
			        serviceHandler = searchwebService.queryOverseasCompleteWords.bind(searchwebService);
				}else if(type === 'mall' || type === 'counterSale'){
                    serviceHandler = searchwebService.queryMallCompleteWords.bind(searchwebService);
				}else if(type === 'super'){
			        serviceHandler = searchwebService.queryMarketCompleteWords.bind(searchwebService);
				}else if(type === 'index'){
                    serviceHandler = searchwebService.queryPlatformCompleteWords.bind(searchwebService);
				}else{
			        return;
				}

                serviceHandler({
					data:{
						word:word
					},
					success(httpData = {}){
						let suggestList = httpData.suggest || [];
						that.suggestWordList = suggestList.map(item => {
							let showItem = {};
							word = word.replace(/\(/g,'\\(').replace(/\)/g,'\\)').replace(/\\/g,'');
							var regExp1 =new RegExp("[\\s\\S]+"+word)
								,regExp2 =new RegExp(word)
								,regExp3 =new RegExp(word+"[\\s\\S]+")
							;
							showItem.text = item;
							showItem.leftText = regExp1.exec(item)?regExp1.exec(item)[0].replace(regExp2,''):'';
							showItem.centerText = regExp2.exec(item)?regExp2.exec(item)[0]:'';
							showItem.rightText = showItem.centerText && regExp3.exec(item)?(regExp3.exec(item)[0]).replace(regExp2,''):'';

							return showItem;
						})
					}
				})
			}
		}
	}
</script>
